import { useLogin } from './useLogin'
import { useBaseMessage } from './useMessage'

/**
 * ! for component only
 * * 判斷能不能操作訂單用
 */
export function useAnonymousOrder(order = ref({})) {
  const nuxtApp = useNuxtApp()
  const { openPureLogin } = useLogin()

  // 更改時間 / 取消 / 刪除 文字
  const warningMessages = reactive({
    header: nuxtApp.$i18n.t('reconfirm_identity_title'),
    message: nuxtApp.$i18n.t('reconfirm_identity_content'),
  })

  const { showMessageModal } = useBaseMessage({ data: toRefs(warningMessages) })

  const isAnonymousOrder = computed(() => !order.value.owner_id)
  const isSameUser = computed(() => !isAnonymousOrder.value && order.value.owner_id === nuxtApp.$auth.user?.uid)

  /**
   * 未登入看已登入訂單 => 登入 dialog
   * 登入看登入訂單 => 不同人 warning dialog
   */
  function checkOrderMutation() {
    if (isSameUser.value || isAnonymousOrder.value) {
      return true
    }
    if (!isAnonymousOrder.value && !nuxtApp.$auth.user) {
      openPureLogin()
      return false
    }
    showMessageModal()
    return false
  }

  return {
    isAnonymousOrder,
    isSameUser,
    checkOrderMutation,
  }
}
